import { Injectable } from '@angular/core';
import { GeneralHttpService } from 'src/app/shared/general-http.service';
import { Aseguradoras } from './aseguradoras.model';

@Injectable({
  providedIn: 'root'
})
export class AseguradorasService {
  listAseguradora:Aseguradoras[];
  constructor(private generalHttp:GeneralHttpService) { }

  private url = "AdmAseguradoras";

  getAseguradoras(){
    return new Promise((resolve, reject) => {
      this.generalHttp.getHttp<Aseguradoras>(this.url).then(r => { 
        this.listAseguradora = r as Aseguradoras[];
        resolve(true);
      })
      error => reject(error);
    });

    //return this.generalHttp.getHttp<Aseguradoras>("AdmAseguradoras").then(r => this.listAseguradora = r as Aseguradoras[])
  }

  updateAseguradoras(){
    return this.generalHttp.putHttpNotValue("AdmAseguradoras/UpdateInsurance")
  }

  getAseguradoraSearch(data: Aseguradoras) {
    return this.generalHttp.postHttp(data, `${this.url}/GetAseguradoraSearch`);
  }

  getAseguradoraById(idAseguradora:number){
    return this.generalHttp.getHttpById(idAseguradora,`${this.url}`);
  }

}
